export const fonts = `"Noto Sans JP", sans-serif`;

export const typography = {
  allVariants: {
    fontFamily: fonts,
    fontStyle: "normal",
  },
  // headline
  head32Bold: {
    fontSize: "32px",
    lineHeight: "150%",
    fontWeight: 700,
  },
  head32Semi: {
    fontSize: "32px",
    lineHeight: "150%",
    fontWeight: 500,
  },
  head28Bold: {
    fontSize: "28px",
    lineHeight: "150%",
    fontWeight: 700,
  },
  head28Semi: {
    fontSize: "28px",
    lineHeight: "150%",
    fontWeight: 500,
  },
  head24Semi: {
    fontSize: "24px",
    lineHeight: "150%",
    fontWeight: 500,
  },
  head24Bold: {
    fontSize: "24px",
    lineHeight: "36px",
    fontWeight: 700,
  },
  head20Semi: {
    fontSize: "20px",
    lineHeight: "150%",
    fontWeight: 500,
  },
  head20Light: {
    fontSize: "20px",
    lineHeight: "30px",
    fontWeight: 200,
  },
  head24Light: {
    fontSize: "24px",
    lineHeight: "36px",
    fontWeight: 100,
  },
  head20Bold: {
    fontSize: "20px",
    lineHeight: "150%",
    fontWeight: 700,
  },
  sub16Light: {
    fontSize: "16px",
    lineHeight: "27px",
    fontWeight: 200,
  },
  // subtitle
  sub16Bold: {
    fontSize: "16px",
    lineHeight: "150%",
    fontWeight: 700,
  },
  sub16Bold170: {
    fontSize: "16px",
    lineHeight: "170%",
    fontWeight: 700,
  },
  sub16Semi: {
    fontSize: "16px",
    lineHeight: "150%",
    fontWeight: 500,
  },
  sub16Semi170: {
    fontSize: "16px",
    lineHeight: "170%",
    fontWeight: 500,
  },
  sub16: {
    fontSize: "16px",
    lineHeight: "150%",
    fontWeight: 400,
  },
  sub16170: {
    fontSize: "16px",
    lineHeight: "170%",
    fontWeight: 400,
  },
  // body
  body14Bold: {
    fontSize: "14px",
    lineHeight: "150%",
    fontWeight: 700,
  },
  body14Bold170: {
    fontSize: "14px",
    lineHeight: "170%",
    fontWeight: 700,
  },
  body14Semi: {
    fontSize: "14px",
    lineHeight: "150%",
    fontWeight: 500,
  },
  body14Semi170: {
    fontSize: "14px",
    lineHeight: "170%",
    fontWeight: 500,
  },
  body14: {
    fontSize: "14px",
    lineHeight: "150%",
    fontWeight: 400,
  },
  body14170: {
    fontSize: "14px",
    lineHeight: "170%",
    fontWeight: 400,
  },
  body14Light: {
    fontSize: "14px",
    lineHeight: "22px",
    fontWeight: 200,
  },
  // caption 12
  cap12Bold: {
    fontSize: "12px",
    lineHeight: "150%",
    fontWeight: 700,
  },
  cap12Bold170: {
    fontSize: "12px",
    lineHeight: "170%",
    fontWeight: 700,
  },
  cap12Semi: {
    fontSize: "12px",
    lineHeight: "150%",
    fontWeight: 500,
  },
  cap12Semi170: {
    fontSize: "12px",
    lineHeight: "170%",
    fontWeight: 500,
  },
  cap12: {
    fontSize: "12px",
    lineHeight: "150%",
    fontWeight: 400,
  },
  cap12170: {
    fontSize: "12px",
    lineHeight: "170%",
    fontWeight: 400,
  },
  // caption 10
  cap10Bold: {
    fontSize: "10px",
    lineHeight: "150%",
    fontWeight: 700,
  },
  cap10Bold170: {
    fontSize: "10px",
    lineHeight: "170%",
    fontWeight: 700,
  },
  cap10Semi: {
    fontSize: "10px",
    lineHeight: "150%",
    fontWeight: 500,
  },
  cap10Semi170: {
    fontSize: "10px",
    lineHeight: "170%",
    fontWeight: 500,
  },
  cap10: {
    fontSize: "10px",
    lineHeight: "150%",
    fontWeight: 400,
  },
  cap10170: {
    fontSize: "10px",
    lineHeight: "170%",
    fontWeight: 400,
  },
  // caption legacy
  cap8Light: {
    fontSize: "8px",
    lineHeight: "14px",
    fontWeight: 200,
  },
  cap10Light: {
    fontSize: "10px",
    lineHeight: "20px",
    fontWeight: 200,
  },
  cap11Light: {
    fontSize: "11px",
    lineHeight: "21px",
    fontWeight: 200,
  },
  cap12Light: {
    fontSize: "12px",
    lineHeight: "23px",
    fontWeight: 200,
  },
  cap13Light: {
    fontSize: "13px",
    lineHeight: "23px",
    fontWeight: 200,
  },
  // link bold
  link16Bold: {
    fontSize: "16px",
    lineHeight: "150%",
    fontWeight: 700,
    textDecoration: "underline",
  },
  link14Bold: {
    fontSize: "14px",
    lineHeight: "150%",
    fontWeight: 700,
    textDecoration: "underline",
  },
  link12Bold: {
    fontSize: "12px",
    lineHeight: "150%",
    fontWeight: 700,
    textDecoration: "underline",
  },
  // link medium
  link16Semi: {
    fontSize: "16px",
    lineHeight: "150%",
    fontWeight: 500,
    textDecoration: "underline",
  },
  link14Semi: {
    fontSize: "14px",
    lineHeight: "150%",
    fontWeight: 500,
    textDecoration: "underline",
  },
  link12Semi: {
    fontSize: "12px",
    lineHeight: "150%",
    fontWeight: 500,
    textDecoration: "underline",
  },
  // link regular
  link16: {
    fontSize: "16px",
    lineHeight: "150%",
    fontWeight: 400,
    textDecoration: "underline",
  },
  link14: {
    fontSize: "14px",
    lineHeight: "150%",
    fontWeight: 400,
    textDecoration: "underline",
  },
  link12: {
    fontSize: "12px",
    lineHeight: "150%",
    fontWeight: 400,
    textDecoration: "underline",
  },
  // number bold
  num16Bold: {
    fontSize: "16px",
    lineHeight: "100%",
    fontWeight: 700,
  },
  num14Bold: {
    fontSize: "14px",
    lineHeight: "100%",
    fontWeight: 700,
  },
  num12Bold: {
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: 700,
  },
  // number medium
  num16Semi: {
    fontSize: "16px",
    lineHeight: "100%",
    fontWeight: 500,
  },
  num14Semi: {
    fontSize: "14px",
    lineHeight: "100%",
    fontWeight: 500,
  },
  num12Semi: {
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: 500,
  },
  // number regular
  num16: {
    fontSize: "16px",
    lineHeight: "100%",
    fontWeight: 400,
  },
  num14: {
    fontSize: "14px",
    lineHeight: "100%",
    fontWeight: 400,
  },
  num12: {
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: 400,
  },
} as const;

declare module "@mui/material/styles" {
  interface TypographyVariants {
    // headline
    head32Bold: React.CSSProperties;
    head32Semi: React.CSSProperties;
    head28Bold: React.CSSProperties;
    head28Semi: React.CSSProperties;
    head24Semi: React.CSSProperties;
    head24Bold: React.CSSProperties;
    head20Semi: React.CSSProperties;
    head20Light: React.CSSProperties;
    head20Bold: React.CSSProperties;
    head24Light: React.CSSProperties;
    // subtitle
    sub16Light: React.CSSProperties;
    sub16Bold: React.CSSProperties;
    sub16Bold170: React.CSSProperties;
    sub16Semi: React.CSSProperties;
    sub16Semi170: React.CSSProperties;
    sub16: React.CSSProperties;
    sub16170: React.CSSProperties;
    // body
    body14Bold: React.CSSProperties;
    body14Bold170: React.CSSProperties;
    body14Semi: React.CSSProperties;
    body14Semi170: React.CSSProperties;
    body14: React.CSSProperties;
    body14170: React.CSSProperties;
    body14Light: React.CSSProperties;
    // caption 12
    cap12Bold: React.CSSProperties;
    cap12Bold170: React.CSSProperties;
    cap12Semi: React.CSSProperties;
    cap12Semi170: React.CSSProperties;
    cap12: React.CSSProperties;
    cap12170: React.CSSProperties;
    // caption 10
    cap10Bold: React.CSSProperties;
    cap10Bold170: React.CSSProperties;
    cap10Semi: React.CSSProperties;
    cap10Semi170: React.CSSProperties;
    cap10: React.CSSProperties;
    cap10170: React.CSSProperties;
    // caption legacy
    cap8Light: React.CSSProperties;
    cap10Light: React.CSSProperties;
    cap11Light: React.CSSProperties;
    cap12Light: React.CSSProperties;
    cap13Light: React.CSSProperties;
    // link
    link16Bold: React.CSSProperties;
    link14Bold: React.CSSProperties;
    link12Bold: React.CSSProperties;
    link16Semi: React.CSSProperties;
    link14Semi: React.CSSProperties;
    link12Semi: React.CSSProperties;
    link16: React.CSSProperties;
    link14: React.CSSProperties;
    link12: React.CSSProperties;
    // number
    num16Bold: React.CSSProperties;
    num14Bold: React.CSSProperties;
    num12Bold: React.CSSProperties;
    num16Semi: React.CSSProperties;
    num14Semi: React.CSSProperties;
    num12Semi: React.CSSProperties;
    num16: React.CSSProperties;
    num14: React.CSSProperties;
    num12: React.CSSProperties;
  }

  // Update the Typography's variant prop options
  interface TypographyVariantsOptions {
    // headline (shared with parent - must be required to match)
    head32Bold: React.CSSProperties;
    head32Semi: React.CSSProperties;
    head28Bold: React.CSSProperties;
    head28Semi: React.CSSProperties;
    head24Semi: React.CSSProperties;
    head24Bold: React.CSSProperties;
    head20Semi: React.CSSProperties;
    head20Bold: React.CSSProperties;
    // headline (module-only)
    head20Light: React.CSSProperties;
    head24Light: React.CSSProperties;
    // subtitle (shared)
    sub16Bold: React.CSSProperties;
    sub16Bold170: React.CSSProperties;
    sub16Semi: React.CSSProperties;
    sub16Semi170: React.CSSProperties;
    sub16: React.CSSProperties;
    sub16170: React.CSSProperties;
    // subtitle (module-only)
    sub16Light: React.CSSProperties;
    // body (shared)
    body14Bold: React.CSSProperties;
    body14Bold170: React.CSSProperties;
    body14Semi: React.CSSProperties;
    body14Semi170: React.CSSProperties;
    body14: React.CSSProperties;
    body14170: React.CSSProperties;
    // body (module-only)
    body14Light: React.CSSProperties;
    // caption 12
    cap12Bold: React.CSSProperties;
    cap12Bold170: React.CSSProperties;
    cap12Semi: React.CSSProperties;
    cap12Semi170: React.CSSProperties;
    cap12: React.CSSProperties;
    cap12170: React.CSSProperties;
    // caption 10
    cap10Bold: React.CSSProperties;
    cap10Bold170: React.CSSProperties;
    cap10Semi: React.CSSProperties;
    cap10Semi170: React.CSSProperties;
    cap10: React.CSSProperties;
    cap10170: React.CSSProperties;
    // caption legacy
    cap8Light: React.CSSProperties;
    cap10Light: React.CSSProperties;
    cap11Light: React.CSSProperties;
    cap12Light: React.CSSProperties;
    cap13Light: React.CSSProperties;
    // link (shared)
    link14Semi: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    // headline
    head32Bold: true;
    head32Semi: true;
    head28Bold: true;
    head28Semi: true;
    head24Semi: true;
    head24Bold: true;
    head20Semi: true;
    head20Light: true;
    head20Bold: true;
    head24Light: true;
    // subtitle
    sub16Light: true;
    sub16Bold: true;
    sub16Bold170: true;
    sub16Semi: true;
    sub16Semi170: true;
    sub16: true;
    sub16170: true;
    // body
    body14Bold: true;
    body14Bold170: true;
    body14Semi: true;
    body14Semi170: true;
    body14: true;
    body14170: true;
    body14Light: true;
    // caption 12
    cap12Bold: true;
    cap12Bold170: true;
    cap12Semi: true;
    cap12Semi170: true;
    cap12: true;
    cap12170: true;
    // caption 10
    cap10Bold: true;
    cap10Bold170: true;
    cap10Semi: true;
    cap10Semi170: true;
    cap10: true;
    cap10170: true;
    // caption legacy
    cap8Light: true;
    cap10Light: true;
    cap11Light: true;
    cap12Light: true;
    cap13Light: true;
    // link
    link16Bold: true;
    link14Bold: true;
    link12Bold: true;
    link16Semi: true;
    link14Semi: true;
    link12Semi: true;
    link16: true;
    link14: true;
    link12: true;
    // number
    num16Bold: true;
    num14Bold: true;
    num12Bold: true;
    num16Semi: true;
    num14Semi: true;
    num12Semi: true;
    num16: true;
    num14: true;
    num12: true;
  }
}
